module.exports = __webpack_public_path__ + "static/media/visit2.7c67bb79.png";